import { useMemo } from 'react';
import { useArticlesSubscriptionsContext } from '@/creditflowresearch/application/ArticlesAndStats/ArticlesSubscriptions';
import type { IFilterGroupConfig } from '@/creditflowresearch/ui/components/creditFlow/articles/posts/PageSubscriptionButton/FilterGroupList';
import { ThemeType } from '@/creditflowresearch/domain/vo/ArticlesAndStats/Articles/themeTypes';
import type { ISubscriptionAdapter } from '@/creditflowresearch/ui/components/creditFlow/articles/posts/PageSubscriptionButton/adapters/types';

interface IAdaptedData {
  filterGroups: IFilterGroupConfig<ThemeType>[],
  regionIds: string[],
  modalTitle: string,
  shouldFilterByProduct: boolean,
}

export const useSubscriptionAdapter = (adapter: ISubscriptionAdapter): IAdaptedData => {
  const context = useArticlesSubscriptionsContext();

  return useMemo(() => {
    const adapterContext = {
      themes: context.themes,
      currentRegion: context.currentRegion,
      currentProduct: context.currentProduct,
      currentMarket: context.currentMarket,
      subscribableRegionIds: context.subscribableRegionIds,
    };

    return {
      filterGroups: adapter.buildFilterGroups(
        context.groupedThemes,
        context.themesIds,
        adapterContext,
      ),
      regionIds: adapter.getRegionIds(adapterContext),
      modalTitle: adapter.getModalTitle(adapterContext),
      shouldFilterByProduct: adapter.shouldFilterByProduct,
    };
  }, [
    adapter,
    context.groupedThemes,
    context.themesIds,
    context.themes,
    context.currentRegion,
    context.currentProduct,
    context.currentMarket,
    context.subscribableRegionIds,
  ]);
};
